import { getCancellationDate } from "@/services/apiCustomer";
import { useQuery } from "@tanstack/react-query";


export function useGetCancellationDate() {
    return useQuery({
        queryKey: ["cancellation-date"],
        queryFn: async () => await getCancellationDate(),
    });
}